module.exports = __webpack_public_path__ + "static/media/coffee-latte-mb-en.fe79e1e5.mp4";